import { isInApp } from '.';
import { getCookie, setCookie } from './cookie';

export function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

/**
 * 生成nano id
 * @return {string} 16长度的字符串
 */
export function nanoId() {
    const ts = ((Math.random() * 1e9) >>> 0);
    const randomer = [];
    const seed = '0123456789ABCDEF';
    for (let i = 0; i < 7; i++) {
        randomer.push(seed.charAt(Math.random() * 16));
    }

    return ts + randomer.join('');
}
/**
 * 提取顶级域名
 * @param {?string=} hostname
 * @return {string} 返回顶级域名
 */
function resolveTopLevelDomain(hostname: string = typeof location !== 'undefined' ? location.hostname : '') {
    if (!hostname) {
        return '';
    }

    const ret = hostname.split('.');
    const len = ret.length;
    return (len <= 2 ? '' : `.${ret[len - 2]}.${ret[len - 1]}`);
}
// 端内或者业务方自行注入
const didKey: string = 'did';
// 之前 weblogger 自行维护的 did key， 因为还是较为通用所以容易和业务方设置的设备 ID 冲突。所以需要换一个更加语义化的名字
const preWebloggerDidKey = '_did';
// 最终语义化的 did key
const lastWebloggerDidKey = 'weblogger_did';
/**
 * 生成did
 * did迭代描述：
 * 一： 直接获取 did 当做设备ID, did 一般为端内 webview 注入。
 * 二：如果不存在 did 则直接生成并存放在 _did 中，获取设备 ID的逻辑就变成了 getCookie('did') || getCookie('_did')，
 *    _did 作为 weblogger 自行维护的设备ID key
 * 三：发现有公司不明业务方也会设置 _did, 且会设置成 http-only，所以需要将 weblogger 自行设置的 key更具体的语义化，避免和业务方设置的设备 ID 冲突。
 *    所以最终的 key 值设为 weblogger_did ，在获取 did 的时候也要兼容之前的 _did 所以最后迭代成：
 *    getCookie('did') || getCookie('_did') || getCookie('weblogger_did')
 * @return {string}
 */
export function generateDID() {
    try {
        // 兼容一下原下发的did逻辑，如果能从did获取，那么就走did
        // 如果不能，那就通过log sdk自行维护的_did来搞
        let did = getCookie(didKey) || getCookie(preWebloggerDidKey) || getCookie(lastWebloggerDidKey);
        if (!did) {
            did = `web_${nanoId()}`;
            const expires = new Date();
            expires.setFullYear(expires.getFullYear() + 1);
            setCookie(lastWebloggerDidKey, did, {
                expires,
                domain: resolveTopLevelDomain(),
                path: '/',
            });
        }
        return did;
    } catch (err) {
        return '';
    }
}
const sessionKey = 'WEBLOGGER_SESSIONID';
// session_id 用来串联在一次打开 App 期间跳转不同页面的用户行为
export const getSessionId = () => {
    let sessionId: string = '';
    const defaultKey = 'session_id';
    try {
        if (isInApp()) {
            sessionId = getCookie(defaultKey) || getCookie('sid'); // 端内从 cookie 中获取客户端传来的 session_id
            if (sessionId) return sessionId;
        } else if (typeof sessionStorage !== 'undefined') {
            sessionId = sessionStorage.getItem(sessionKey) || '';
            if (!sessionId) {
                sessionId = uuid();
                sessionStorage.setItem(sessionKey, sessionId);
            }
        }
    } catch (err) {
        sessionId = uuid();
    }
    return sessionId || uuid();
};
